import { useMemo } from 'react';
import { ItemTypes } from '../../../components/gantt/dragDrop/types';
import { SubsectionConfig } from '../../../components/gantt/gantt/GanttProvider';
import { useSystemSettings } from '../../../services/settings/SystemSettingsProvider';
import { useGetBreakOffsets } from '../../../services/settings/useGetBreakOffsets';
import { useTasks } from '../../../services/tasks/useTasks';

export const useSubsections = () => {
  const tasks = useTasks();
  const offsetData = useGetBreakOffsets();
  const increment = useSystemSettings(state => state.settings.minuteIncrement);

  return useMemo(() => {
    const basicSubsections: SubsectionConfig[] = [
      {
        id: ItemTypes.BREAK,
        defaultLength: 60 * 60,
        startBuffer: offsetData?.timeOffsetBeforeFirstBreak || 0,
        endBuffer: offsetData?.timeOffsetAfterLastBreak || 0,
        minLength: increment * 60
      }
    ];

    const taskSubsections: SubsectionConfig[] = tasks.map(task => ({
      id: task.id.toString(),
      defaultLength: task.defaultDuration * 60,
      startBuffer: 0,
      endBuffer: 0,
      minLength: task.defaultDuration === 0 ? 0 : increment * 60,
      maxLength: task.defaultDuration === 0 ? 0 : undefined
    }));

    return [...basicSubsections, ...taskSubsections];
  }, [increment, offsetData?.timeOffsetAfterLastBreak, offsetData?.timeOffsetBeforeFirstBreak, tasks]);
};
